import template from './sw-cms-preview-product-three-column.html.twig';
import './sw-cms-preview-product-three-column.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
